var _rect, _rect2, _path, _line, _rect3, _rect4, _path2, _line2, _rect5, _rect6, _path3, _line3, _rect7, _rect8, _path4, _line4, _rect9, _rect10, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 33,
    viewBox: "0 0 752 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#096F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8123 22.5L15.8123 11.3L17.6203 11.3L17.6203 22.5L15.8123 22.5ZM13.5723 12.948L13.5723 11.3L17.4603 11.3L17.4603 12.948L13.5723 12.948Z",
    fill: "#096F00"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 15.5,
    x2: 175,
    y2: 15.5,
    stroke: "#DAE0E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DAE0E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.12 21.412L196.248 17.028C196.589 16.6653 196.867 16.34 197.08 16.052C197.293 15.764 197.448 15.492 197.544 15.236C197.64 14.98 197.688 14.7187 197.688 14.452C197.688 13.9507 197.523 13.5613 197.192 13.284C196.872 12.996 196.461 12.852 195.96 12.852C195.427 12.852 194.957 12.9853 194.552 13.252C194.147 13.5187 193.784 13.9347 193.464 14.5L192.184 13.444C192.621 12.6867 193.16 12.116 193.8 11.732C194.44 11.3373 195.181 11.14 196.024 11.14C196.717 11.14 197.325 11.2787 197.848 11.556C198.371 11.8333 198.776 12.2227 199.064 12.724C199.352 13.2147 199.496 13.7853 199.496 14.436C199.496 14.9053 199.437 15.3267 199.32 15.7C199.213 16.0627 199.027 16.4307 198.76 16.804C198.493 17.1667 198.125 17.5933 197.656 18.084L194.488 21.364L192.12 21.412ZM192.12 22.5V21.412L193.704 20.852L199.72 20.852V22.5L192.12 22.5Z",
    fill: "#5F6D7E"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    y1: 15.5,
    x2: 355,
    y2: 15.5,
    stroke: "#DAE0E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DAE0E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375.616 22.66C374.869 22.66 374.192 22.5267 373.584 22.26C372.986 21.9827 372.48 21.5827 372.064 21.06L373.312 19.812C373.536 20.1533 373.85 20.4253 374.256 20.628C374.661 20.8307 375.104 20.932 375.584 20.932C376.042 20.932 376.437 20.8467 376.768 20.676C377.098 20.5053 377.354 20.2653 377.536 19.956C377.728 19.6467 377.824 19.2893 377.824 18.884C377.824 18.4573 377.728 18.0947 377.536 17.796C377.354 17.4973 377.088 17.268 376.736 17.108C376.394 16.9373 375.978 16.852 375.488 16.852C375.296 16.852 375.098 16.868 374.896 16.9C374.693 16.9213 374.512 16.9587 374.352 17.012L375.168 15.956C375.392 15.8707 375.626 15.8013 375.872 15.748C376.128 15.684 376.373 15.652 376.608 15.652C377.184 15.652 377.701 15.7907 378.16 16.068C378.629 16.3453 378.997 16.7347 379.264 17.236C379.541 17.7267 379.68 18.308 379.68 18.98C379.68 19.7053 379.509 20.3453 379.168 20.9C378.826 21.4547 378.352 21.8867 377.744 22.196C377.136 22.5053 376.426 22.66 375.616 22.66ZM374.352 17.012V15.924L377.344 12.436L379.552 12.388L376.432 15.972L374.352 17.012ZM372.624 12.948V11.3L379.552 11.3V12.388L377.968 12.948L372.624 12.948Z",
    fill: "#5F6D7E"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 397,
    y1: 15.5,
    x2: 535,
    y2: 15.5,
    stroke: "#DAE0E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 540.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 540.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DAE0E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M551.659 18.5L555.643 11.3L557.723 11.3L553.643 18.5L551.659 18.5ZM551.659 19.62V18.5L552.443 17.972L560.347 17.972V19.62L551.659 19.62ZM556.971 22.5V15.172L558.779 15.172V22.5L556.971 22.5Z",
    fill: "#5F6D7E"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 577,
    y1: 15.5,
    x2: 715,
    y2: 15.5,
    stroke: "#DAE0E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 720.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 720.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DAE0E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M735.593 22.66C734.814 22.66 734.121 22.5267 733.513 22.26C732.905 21.9827 732.393 21.5827 731.977 21.06L733.225 19.812C733.449 20.1533 733.763 20.4253 734.169 20.628C734.585 20.8307 735.049 20.932 735.561 20.932C736.03 20.932 736.441 20.8467 736.793 20.676C737.145 20.5053 737.422 20.26 737.625 19.94C737.827 19.62 737.929 19.2413 737.929 18.804C737.929 18.3453 737.827 17.9667 737.625 17.668C737.433 17.3587 737.171 17.1293 736.841 16.98C736.521 16.82 736.174 16.74 735.801 16.74C735.374 16.74 734.99 16.788 734.649 16.884C734.318 16.98 733.993 17.1507 733.673 17.396L733.721 16.244C733.891 16.02 734.089 15.8387 734.313 15.7C734.537 15.5507 734.798 15.4387 735.097 15.364C735.395 15.2893 735.747 15.252 736.153 15.252C736.942 15.252 737.603 15.4173 738.137 15.748C738.681 16.0787 739.091 16.5213 739.369 17.076C739.646 17.62 739.785 18.228 739.785 18.9C739.785 19.6253 739.603 20.2707 739.241 20.836C738.889 21.4013 738.398 21.8493 737.769 22.18C737.139 22.5 736.414 22.66 735.593 22.66ZM733.673 17.396L732.665 16.388L733.161 11.3L734.841 11.3L734.265 16.596L733.673 17.396ZM733.481 12.948L733.161 11.3L739.161 11.3V12.948L733.481 12.948Z",
    fill: "#5F6D7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper);
export default __webpack_public_path__ + "static/media/Stepper.466a71c175e54a9f42f5da3dd77350fe.svg";
export { ForwardRef as ReactComponent };